import { FC, ReactNode, useMemo } from 'react';
import { AbilityContext } from './AbilityContext';
import { defineAbilitiesFor } from './defineAbilities';
import { mapLegacyRoleToUserRole } from './utils/roleMapper';
import { isUserOnboarded } from '@utils/helpers';
import { isMasterStudent } from '@new/features/degree/utils/isMasterStudent';
import type { User } from '@teachur/http-client';

type AbilityUser = Pick<User, 'role'> & Partial<Pick<User, 'enrolledDegrees' | 'onboarding'>>;

interface AbilityProviderProps {
  user: AbilityUser;
  children: ReactNode;
}

export const AbilityProvider: FC<AbilityProviderProps> = ({ user, children }) => {
  const ability = useMemo(() => {
    const role = mapLegacyRoleToUserRole(user.role);
    const enrolledDegreeIds = user.enrolledDegrees?.map((ed) => ed.degreeId) ?? [];
    const isOnboarded = !!(user.onboarding && isUserOnboarded(user.onboarding));
    const isMaster = isMasterStudent(user.enrolledDegrees);

    return defineAbilitiesFor(role, enrolledDegreeIds, isOnboarded, isMaster);
  }, [user]);

  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
};
